import React, { useEffect } from "react";
import { Form, Input, Button, Space, Select } from "antd";
import { useAssignedOrdersStore } from "modules/order_management/store";
import { useClinicStore } from "./store";
import { toast } from "react-toastify";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { ROLE_FOR_FILTER, STORE_TYPE } from "./commonFunction";
const { Item } = Form;

function AddClinic() {
  const { fetchDoctorRoleData} = useAssignedOrdersStore();
  const { postClinic } = useClinicStore();
  const [form] = Form.useForm();

  useEffect(() => {
    fetchDoctorRoleData();
  }, []);

  const onFinish = (values) => {
    const payload = {
      clinicName: values.clinicName,
      address: values.address,
      locality: values.locality,
      pincode: values.pincode,
      gst_number: values.gst_number,
      type: values.type,
      persons: values.employees.map((employee) => ({
        phone_number: employee.emp_phone,
        name: employee.emp_name,
        email: employee.emp_email,
        type: employee.emp_type,
      })),
      city: values.city,
      location: values.location
    };

    postClinic(payload)
      .then(() => {
        toast.success("Clinic added successfully!");
        form.resetFields();
      })
      .catch((error) => {
        toast.error("Failed to add clinic!");
      });
  };

  return (
    <div className="d-flex flex-column gap-2">
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
        initialValues={{ employees: [{}] }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Item
            label="Clinic Name"
            name="clinicName"
            rules={[{ required: true, message: "Please add clinic name!" }]}
            style={{ flex: 1, marginRight: "10px" }}
          >
            <Input />
          </Item>
          <Item
            label="City"
            name="city"
            rules={[{ required: true, message: "Please add city!" }]}
            style={{ flex: 1, marginLeft: "10px" }}
          >
            <Input />
          </Item>
          <Item
            label="Locality"
            name="locality"
            rules={[{ required: true, message: "Please add locality!" }]}
            style={{ flex: 1, marginRight: "10px", marginLeft: "10px" }}
          >
            <Input />
          </Item>
          <Item
            label="Pincode"
            name="pincode"
            rules={[{ required: true, message: "Please add pincode!" }]}
            style={{ flex: 1 }}
          >
            <Input />
          </Item>
          <Item
            label="Address"
            name="address"
            rules={[{ required: true, message: "Please add address!" }]}
            style={{ flex: 1, marginLeft: "10px" }}
          >
            <Input />
          </Item>
          <Item
            label="Location"
            name="location"
            rules={[{ required: true, message: "Please add location!" }]}
            style={{ flex: 1, marginLeft: "10px" }}
          >
            <Input />
          </Item>
          <Item
            label="Clinic Type"
            name="type"
            rules={[{ required: true, message: "Please add Type" }]}
          >
            <Select placeholder="Select Type" style={{ width: "200px", marginLeft:"10px" }}>
              {STORE_TYPE?.map((role) => (
                <Select.Option key={role.name} value={role.value}>
                  {role.name}
                </Select.Option>
              ))}
            </Select>
          </Item>
        </div>
        <Form.List name="employees">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Space
                  key={key}
                  style={{ display: "flex", marginBottom: 8 }}
                  align="baseline"
                >
                  <Item
                    {...restField}
                    label="Name"
                    name={[name, "emp_name"]}
                    rules={[{ required: true, message: "Missing doctor name" }]}
                  >
                    <Input placeholder="Name" style={{ width: "200px" }} />
                  </Item>
                  <Item
                    {...restField}
                    label="Phone"
                    name={[name, "emp_phone"]}
                    rules={[
                      { required: true, message: "Missing phone number" },
                    ]}
                  >
                    <Input
                      placeholder="Phone Number"
                      style={{ width: "200px" }}
                    />
                  </Item>
                  <Item
                    {...restField}
                    label="Email"
                    name={[name, "emp_email"]}
                    rules={[{ required: true, message: "Missing email" }]}
                  >
                    <Input placeholder="Email" style={{ width: "250px" }} />
                  </Item>
                  <Item
                    {...restField}
                    label="Type"
                    name={[name, "emp_type"]}
                    rules={[{ required: true, message: "Missing type" }]}
                  >
                    <Select
                      placeholder="Select Type"
                      style={{ width: "200px" }}
                    >
                      {ROLE_FOR_FILTER?.map((role) => (
                        <Select.Option key={role.name} value={role.value}>
                          {role.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Item>
                  <MinusCircleOutlined onClick={() => remove(name)} />
                </Space>
              ))}
              <Item>
                <Button
                  type="dashed"
                  onClick={() => add()}
                  icon={<PlusOutlined />}
                  style={{ width: "150px" }} // Decreased width
                >
                  Add Employees
                </Button>
              </Item>
            </>
          )}
        </Form.List>
        <Item>
          <Button type="primary" className="float-end" htmlType="submit">
            Submit
          </Button>
        </Item>
      </Form>
    </div>
  );
}

export default AddClinic;
